import React from 'react';
import { connect } from 'react-redux';
import { options } from 'config/reactRedux';
import { getEdition } from 'selectors/getEdition';
import logos from 'config/logos';
import Link from 'components/link';
import NavExplore from 'components/nav/navExplore';
import withStyles from 'isomorphic-style-loader/withStyles';
import PrimaryNav from 'components/nav/primaryNav';
import ToggleContainer from 'components/toggleContainer';
import SearchForm from 'components/searchForm';
import MenuNav from 'components/nav/menuNav';
import I18n from 'components/i18n';
import CallToAction from 'components/callToAction';
import { buildCTALink } from 'utils/url';
import { LANGUAGES } from 'config/types/prop';
import Logo from './Logo';

import styles from './header.css';

const Header = ({ currentEdition }) => {
  const goLink = buildCTALink(currentEdition);
  const ctaLabel = <I18n field="try-babbel" defaultText="Try Babbel" />;

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.logo}>
          <Link to={`/${currentEdition}/magazine`}>
            <Logo currentEdition={currentEdition} />
          </Link>
        </div>
        <div className={styles.lgScreenNavContainer}>
          <div className={styles.ctaContainer}>
            <CallToAction
              isInHeader
              text={ctaLabel}
              url={goLink}
            />
          </div>
        </div>
        <div className={styles.hamburgerMenu}>
          <ToggleContainer
            button={{
              label: 'Toggle Menu',
              icon: 'hamburger',
            }}
            modalTitle="Menu"
            interaction="fromRight"
          >
            <MenuNav />
          </ToggleContainer>
        </div>
      </div>
      <div className={styles.desktopHeaderNav}>
        <div className={styles.desktopHeaderNavContent}>
          <div>
            <NavExplore isDesktopHeaderNav />
          </div>
          <ToggleContainer
            button={{
              label: 'Toggle Search',
              icon: 'search',
            }}
            modalTitle="Search"
            interaction="fromRight"
            className={styles.searchToggleContainer}
          >
            <SearchForm />
          </ToggleContainer>
        </div>
      </div>
      <PrimaryNav />
    </div>
  );
};

Header.propTypes = {
  currentEdition: LANGUAGES.isRequired,
};

const mapStateToProps = (state) => ({
  currentEdition: getEdition(state),
});

const withRedux = connect(
  mapStateToProps,
  undefined,
  undefined,
  options,
);

const wrapWithStyles = withStyles(styles);

export default wrapWithStyles(withRedux(Header));
